import React from "react";
import styled from "styled-components";
import { Button } from "../elements/Button";
// import { NavLink } from "react-router-dom";
import { FaFacebook, FaWhatsapp } from "react-icons/fa";
import { IconName, SiGooglemybusiness } from "react-icons/si";

const Footer = () => {
  
  return (
    <Wrapper>
      <section className="contact-short">
        <div className="grid grid-two-column">
          <div className="">
            <h3>Ready to get started?</h3>
            <h3>Talk to us now</h3>
          </div>

          <div className="contact-short-btn">
            <Button className="btn hireme-btn">
              <a href={`tel: +919982852960`}> Get started</a>
            </Button>
          </div>
        </div>
      </section>

      {/* footer section  */}

      <footer>
        <div className="container grid grid-four-column">
          <div className="footer-about">
            <h4 style={{marginBottom:"0rem"}}>Director :</h4>
            <h3>Aniket Modi</h3>
            {/* <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</p> */}
          </div>

          {/* 2nd column */}
          <div className="footer-subscribe">
            <h3>Subscribe to get important updates</h3>
            <form action="#">
              <input
                type="email"
                required
                autoComplete="off"
                placeholder="Email"
              />
              <input type="submit" value="Subscribe" />
            </form>
          </div>

          {/* 3rs column  */}
          <div className="footer-social">
            <h3>Follows Us</h3>
            <div className="footer-social--icons">
              <a href={`https://www.facebook.com/Kotaonlinehometuitions/?show_switched_toast=0&show_invite_to_follow=0&show_switched_tooltip=0&show_podcast_settings=0&show_community_review_changes=0&show_community_rollback=0&show_follower_visibility_disclosure=0`}>
              <div>
                <FaFacebook className="icons" />
              </div>
              </a>
              <a href={`https://www.google.com/search?rlz=1C1CHBF_enIN1040IN1040&cs=1&output=search&q=Kota%27s+online/offline+home+tuitions+for+cbse+and+rbse+(5+-+10)&ludocid=6751752660398487631&gsas=1&lsig=AB86z5Ur7PG9ShSAeka0Q7HvdI4N&sa=X&ved=2ahUKEwiytpjNsv79AhUTcGwGHU5LCs4Qj9IGKAB6BAgcEAE&biw=1600&bih=757&dpr=1&bshm=lbsc/1`}>
              <div>
              
                <SiGooglemybusiness className="icons" />
              </div>
              </a>
              <div>
                <a href={`https://wa.me/919982852960?text=Hello`}>
                  <FaWhatsapp className="icons" />
                </a>
              </div>
            </div>
          </div>

          {/* 4th column  */}
          <div className="footer-contact">
            <h3>Call Us :</h3>
            <h3>+91 9982852960</h3>
          </div>
        </div>

        {/* bottom section  */}
               <div className="footer-bottom--section">
          <hr />
          <div className="container grid grid-two-column">
            <p>@{new Date().getFullYear()} Aniket Modi. All Rights Reserved</p>
            <div>
              <p>PRIVACY POLICY</p>
              <p>TERMS & CONDITIONS</p>
            </div>
          </div>
        </div>
      </footer>
    </Wrapper>
  );
};

const Wrapper = styled.section`

.contact-short {
    max-width: 80vw;
    margin: auto;
    padding: 5rem 10rem;
    background-color: ${({ theme }) => theme.colors.bg};
    border-radius: 1rem;
    box-shadow: ${({ theme }) => theme.colors.shadowSupport};
    transform: translateY(50%);
    div div{
      margin: 2rem;
      h3{
      font-size: 3rem;
      }
    } 
  }

  .footer-subscribe{
    form{
      display: flex;
      input{
        // border-radius: 10%;
      }
    }
  }



  .contact-short-btn {
    justify-self: end;
    align-self: center;
    a{
      font-size: 2rem;
    }
  }
  .grid {
    display: grid;
    gap: 0rem;
  }
  
  .grid-two-column {
    grid-template-columns: repeat(2, 1fr);
  }
  .grid-four-column {
    grid-template-columns: 1fr 1.2fr .5fr .8fr;
    gap: 2rem
  }
  footer {
    padding: 14rem 0 9rem 0;
    background-color: ${({ theme }) => theme.colors.footer_bg};
    div{
      padding:1rem;
    }
    
      p{
        
        text-align: center;
      }
    
    h3, h4 {
      color: ${({ theme }) => theme.colors.hr};
      margin-bottom: 2.4rem;
      font-size: 2.5rem;
    }
    p {
      color: ${({ theme }) => theme.colors.white};
    }
    .footer-social--icons {
      display: flex;
      gap: 2rem;
      div {
        padding: 1rem;
        border-radius: 50%;
        border: 2px solid ${({ theme }) => theme.colors.white};
        .icons {
          color: ${({ theme }) => theme.colors.white};
          font-size: 2.4rem;
          position: relative;
          cursor: pointer;
        }
      }
    }
    .footer-bottom--section {
      padding-top: 9rem;
      hr {
        margin-bottom: 2rem;
        color: ${({ theme }) => theme.colors.hr};
        height: 0.1px;
      }
      p{
        font-size:2.5rem;
      }
  }
     footer .footer-bottom--section {
      padding-top: 3.2rem;
    }
  }
  @media (max-width:998px) {
        h3{
            // font-size: 3rem;
          }
          .contact-short-btn {
            a{
              font-size: 2.5rem;
            }
          }
          footer{
            h3{
              font-size: 3.2rem;
            }
          }
  }
  
  @media (max-width:768px) {
    .grid-three-column, .grid-four-column {
      grid-template-columns: 1fr;
  }
    .contact-short {
      max-width: 95vw;
      padding: 2rem 0rem;
      display: flex;
      justify-content: center;
      align-items: center;
      

    
  }
  @media (max-width:599px) {
   
  }
`;

export default Footer;
